import { Component } from 'react';

import Dropdown from '../dropdown/dropdown';
import { DropdownProps } from '../dropdown/dropdown';
import style from './input-with-dropdown.component.module.scss';

export interface InputWithDropdownValue {
    input: number | string;
    dropdown: any;
}

interface InputWithDropdownProps<T> extends DropdownProps<T> {
    inputValue: any;
    inputType: 'text' | 'number' | 'email';
    onValueChange: (value) => void;
}

export default class InputWithDropdownComponent<T> extends Component<InputWithDropdownProps<T>> {
    inputValue;
    dropdownValue;

    componentInitialized = false;

    size = 'sm';

    constructor(props: InputWithDropdownProps<T>) {
        super(props);
        this.inputValue = props.inputValue;
        this.dropdownValue = props.initialValue;
    }

    componentDidMount() {
        if (this.props.emitInitialValueOnInit) {
            this.valueChanged();
        }
        this.componentInitialized = true;
    }


    inputChanged(e) {
        this.inputValue = e.target.value;
        this.valueChanged();
    }

    dropdownValueChanged(value) {
        this.dropdownValue = value;
        if (this.componentInitialized) {
            this.valueChanged();
        }
    }

    valueChanged() {
        this.props.onValueChange({
            input: this.inputValue,
            dropdown: this.dropdownValue,
        });
    }

    render() {
        return (
            <div className={style['input-dropdown-container']}>
                <div className={style['input-dropdown']}>
                    <div className={`${style['input-group']} x-input-group input-group-${this.size}`}>
                        {
                            this.props.label && <div className="input-group-prepend">
                                <button type="button" className="input-group-text btn btn-secondary" disabled>{this.props.label}</button>
                            </div>
                        }

                        <input className="form-control" onInput={e => this.inputChanged(e)} type={this.props.inputType} value={this.props.inputValue} />
                        <div className={`${style['input-group-append']} input-group-append`} id="button-addon4">
                            <Dropdown firstBtnStyles={{ borderRadius: '0px' }} {...this.props}
                                onSelect={(value) => this.dropdownValueChanged(value)}
                                label={null}
                            ></Dropdown>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}